const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const EVENT_KEYS = Object.freeze([
  'discussionId',
  'latestMessageId',
  'mindmapId',
  'nodeId',
  'type',
  'v',
]);

export function isNamedDiscussionCollaborator({
  currentUserId,
  isLoggedIn,
  accessRole,
  accessSource,
}) {
  return Boolean(
    currentUserId
    && isLoggedIn
    && ['owner', 'editor'].includes(accessRole)
    && ['owner', 'member'].includes(accessSource)
  );
}

export function parseNodeDiscussionChangedEvent(payload, expectedMindmapId) {
  if (
    typeof payload !== 'string'
    || payload.length > 1024
    || !UUID_PATTERN.test(expectedMindmapId || '')
  ) {
    return null;
  }
  try {
    const parsed = JSON.parse(payload);
    if (
      !parsed
      || typeof parsed !== 'object'
      || Array.isArray(parsed)
      || parsed.v !== 1
      || parsed.type !== 'node_discussion.changed'
      || !EVENT_KEYS.every((key) => Object.hasOwn(parsed, key))
      || Object.keys(parsed).sort().join(',') !== EVENT_KEYS.join(',')
      || parsed.mindmapId !== expectedMindmapId
      || !UUID_PATTERN.test(parsed.mindmapId)
      || !UUID_PATTERN.test(parsed.nodeId)
      || !UUID_PATTERN.test(parsed.discussionId)
      || !UUID_PATTERN.test(parsed.latestMessageId)
    ) {
      return null;
    }
    return Object.freeze({
      v: 1,
      type: 'node_discussion.changed',
      mindmapId: parsed.mindmapId,
      nodeId: parsed.nodeId,
      discussionId: parsed.discussionId,
      latestMessageId: parsed.latestMessageId,
    });
  } catch {
    return null;
  }
}
